export enum ScheduleHAdditionalInformationGridType {
    AssocCallSigns = 'assocCallSigns',
    AssocControlPoints = 'assocControlPoints',
}
